// src/pages/AuthPage.js - Beautiful Login/Register System
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    address: ''
  });
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const { login, register, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (isLogin) {
      // Login
      const result = await login(formData.email, formData.password);
      if (result.success) {
        setMessage(result.message);
        setMessageType('success');
        setTimeout(() => navigate(from, { replace: true }), 1500);
      } else {
        setMessage(result.message);
        setMessageType('error');
      }
    } else {
      // Register
      if (formData.password !== formData.confirmPassword) {
        setMessage('Passwords do not match!');
        setMessageType('error');
        return;
      }

      const result = await register(formData);
      if (result.success) {
        setMessage(result.message);
        setMessageType('success');
        setTimeout(() => navigate(from, { replace: true }), 1500);
      } else {
        setMessage(result.message);
        setMessageType('error');
      }
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #FFF8DC, #f8f9fa)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '30px',
        padding: '3rem',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '500px',
        border: '2px solid #f8f9fa'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '900',
            color: '#008751',
            marginBottom: '0.5rem'
          }}>
            🍽️ TiwaTinwa 🇳🇬
          </h1>
          <p style={{
            color: '#6b7280',
            fontSize: '1.1rem'
          }}>
            {isLogin ? 'Welcome back! Sign in to your account' : 'Create your account to get started'}
          </p>
        </div>

        {/* Toggle Buttons */}
        <div style={{
          display: 'flex',
          background: '#f8f9fa',
          borderRadius: '20px',
          padding: '0.3rem',
          marginBottom: '2rem'
        }}>
          <button
            onClick={() => {
              setIsLogin(true);
              setMessage('');
            }}
            style={{
              flex: 1,
              padding: '1rem',
              borderRadius: '17px',
              border: 'none',
              fontWeight: '700',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              background: isLogin ? 'linear-gradient(135deg, #008751, #fb923c)' : 'transparent',
              color: isLogin ? 'white' : '#6b7280'
            }}
          >
            <span style={{ pointerEvents: 'none' }}>🔑 Login</span>
          </button>
          <button
            onClick={() => {
              setIsLogin(false);
              setMessage('');
            }}
            style={{
              flex: 1,
              padding: '1rem',
              borderRadius: '17px',
              border: 'none',
              fontWeight: '700',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              background: !isLogin ? 'linear-gradient(135deg, #008751, #fb923c)' : 'transparent',
              color: !isLogin ? 'white' : '#6b7280'
            }}
          >
            <span style={{ pointerEvents: 'none' }}>👤 Register</span>
          </button>
        </div>

        {/* Message */}
        {message && (
          <div style={{
            padding: '1rem',
            borderRadius: '15px',
            marginBottom: '1.5rem',
            textAlign: 'center',
            fontWeight: '600',
            background: messageType === 'success' ? '#dcfce7' : '#fef2f2',
            color: messageType === 'success' ? '#16a34a' : '#dc2626',
            border: `2px solid ${messageType === 'success' ? '#bbf7d0' : '#fecaca'}`
          }}>
            {message}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Name field for registration */}
          {!isLogin && (
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '700',
                color: '#008751'
              }}>
                👤 Full Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required={!isLogin}
                placeholder="Enter your full name"
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '15px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#008751';
                  e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          {/* Email */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '700',
              color: '#008751'
            }}>
              📧 Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="Enter your email"
              style={{
                width: '100%',
                padding: '1rem',
                border: '2px solid #e9ecef',
                borderRadius: '15px',
                fontSize: '1rem',
                outline: 'none',
                transition: 'all 0.3s ease'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#008751';
                e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e9ecef';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Phone for registration */}
          {!isLogin && (
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '700',
                color: '#008751'
              }}>
                📱 Phone Number
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required={!isLogin}
                placeholder="Enter your phone number"
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '15px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#008751';
                  e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          {/* Password */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: '700',
              color: '#008751'
            }}>
              🔒 Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '1rem',
                border: '2px solid #e9ecef',
                borderRadius: '15px',
                fontSize: '1rem',
                outline: 'none',
                transition: 'all 0.3s ease'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#008751';
                e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e9ecef';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Confirm Password for registration */}
          {!isLogin && (
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '700',
                color: '#008751'
              }}>
                🔒 Confirm Password
              </label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required={!isLogin}
                placeholder="Confirm your password"
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '15px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#008751';
                  e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          {/* Address for registration */}
          {!isLogin && (
            <div style={{ marginBottom: '2rem' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '700',
                color: '#008751'
              }}>
                📍 Delivery Address
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                required={!isLogin}
                placeholder="Enter your delivery address"
                rows="3"
                style={{
                  width: '100%',
                  padding: '1rem',
                  border: '2px solid #e9ecef',
                  borderRadius: '15px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  resize: 'vertical'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#008751';
                  e.target.style.boxShadow = '0 0 15px rgba(0, 135, 81, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e9ecef';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #008751, #fb923c)',
              color: 'white',
              border: 'none',
              padding: '1.2rem',
              borderRadius: '20px',
              fontWeight: '900',
              fontSize: '1.1rem',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              marginBottom: '1rem'
            }}
            onMouseOver={(e) => {
              if (!isLoading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 10px 30px rgba(0, 135, 81, 0.4)';
              }
            }}
            onMouseOut={(e) => {
              if (!isLoading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }
            }}
          >
            <span style={{ pointerEvents: 'none' }}>
              {isLoading ? '⏳ Processing...' : isLogin ? '🔑 Sign In' : '👤 Create Account'}
            </span>
          </button>
        </form>

        {/* Footer */}
        <div style={{
          textAlign: 'center',
          color: '#6b7280',
          fontSize: '0.9rem'
        }}>
          {isLogin ? "Don't have an account? " : "Already have an account? "}
          <button
            onClick={() => {
              setIsLogin(!isLogin);
              setMessage('');
              setFormData({
                name: '',
                email: '',
                password: '',
                confirmPassword: '',
                phone: '',
                address: ''
              });
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#008751',
              fontWeight: '700',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            <span style={{ pointerEvents: 'none' }}>
              {isLogin ? 'Create one here' : 'Sign in here'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;